<script setup>
import { onMounted, ref } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const props = defineProps({
  lat: { type: Number, required: true },
  lng: { type: Number, required: true },
  link: { type: String, default: '' },
  zoom: { type: Number, default: 15 },
});

const mapContainer = ref(null);

const openInNewTab = () => {
  if (props.link) {
    window.open(props.link, '_blank');
  }
};

onMounted(() => {
  if (!mapContainer.value) return;

  const map = L.map(mapContainer.value, {
    zoomControl: false,
    attributionControl: false,
    dragging: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    boxZoom: false,
    keyboard: false,
  }).setView([props.lat, props.lng], props.zoom);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
  }).addTo(map);

  L.circleMarker([props.lat, props.lng], {
    radius: 8,
    fillColor: '#ef4444',
    color: '#ffffff',
    weight: 2,
    opacity: 1,
    fillOpacity: 1,
  }).addTo(map);
});
</script>

<template>
  <a
    :href="link || `https://maps.google.com/?q=${lat},${lng}`"
    target="_blank"
    rel="noreferrer noopener nofollow"
    class="block h-32 w-full mt-2 rounded-lg overflow-hidden border border-n-container cursor-pointer"
    @click.prevent="openInNewTab"
  >
    <div ref="mapContainer" class="h-full w-full pointer-events-none" />
  </a>
</template>
